import moment from "moment";
import {v4} from "uuid";
import s3Api from "../../api/s3Api";

const fileRegex = /(.*)v(.*)\.(.*)/;

export const platformGuideDirectory = (process.env.NODE_ENV === 'local' ? 'dev' :
                                        process.env.NODE_ENV === 'beta' ? 'production' //beta페이즈는 production을 참조
                                                                       : process.env.NODE_ENV) +
                                      "/platform-guide/";

export class GuideFile {
  uuid = "";
  key = "";

  directory = "";
  fileName = "";
  guideName = "";
  versionName = "";
  componentName = "";
  lastModifiedAt = "";

  file = null;

  constructor(guideFile) {
    this.uuid = v4().toString();
    if (guideFile == null) {
      return;
    }
    const {key, lastModifiedAt} = guideFile;
    this.key = key;

    const splitBySlash = key.split('/');

    this.fileName = splitBySlash.length < 1 ? null :
                    splitBySlash[splitBySlash.length - 1];
    this.directory = key.substr(0, key.length - this.fileName.length);

    const regexExec = fileRegex.exec(this.fileName);
    if (regexExec?.length > 2) {
      this.guideName = fileRegex.exec(this.fileName)[1].trim();
      this.versionName = fileRegex.exec(this.fileName)[2];
      this.componentName = splitBySlash[2];
      this.lastModifiedAt = moment(lastModifiedAt).format('YYYY.MM.DD');
    }
  }

  loadMetadata(){
    return s3Api.getMetadata(this.key)
      .then(response => {
        const metaData = response?.data;
        if (!!metaData) {
          this.guideName = decodeURIComponent(metaData.name);
          this.versionName = decodeURIComponent(metaData.version);
        }
        return response;
      });
  }
}

const devDownloadFiles = [
  {
    fileName: "png",
    directory: "광고주센터",
    pages: ["DrawDetailEdit"],
  },
  {
    fileName: "txt",
    directory: "광고주센터",
    pages: ["DrawDetailEdit", "DrawPrizeInfo"],
  },
]

const sandboxDownloadFiles = [
  {
    fileName: "123123",
    directory: "광고주센터",
    pages: ["DrawDetailEdit"],
  },
  {
    fileName: "test",
    directory: "광고주센터",
    pages: ["DrawDetailEdit", "DrawPrizeInfo"],
  },
];

const betaDownloadFiles = [
  {
    fileName: "[KG] 룰렛 등록가이드",
    directory: "룰렛",
    pages: ["DrawDetailEdit", "DrawPrizeInfo"],
  },
  {
    fileName: "[KG] 룰렛 소재가이드",
    directory: "룰렛",
    pages: ["DrawDetailEdit"],
  },
];


export const downloadFiles = process.env.NODE_ENV === "local" ? devDownloadFiles :
                            process.env.NODE_ENV === "sandbox" ? sandboxDownloadFiles : betaDownloadFiles